import axios from 'axios';
import { API_URL, ENDPOINTS } from '../constants/api.constant';

export const getPositions = async () => {
  try {
    const response = await axios.get(`${API_URL}${ENDPOINTS.SETTINGS.POSITIONS}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const createPosition = async (data) => {
  try {
    const response = await axios.post(`${API_URL}${ENDPOINTS.SETTINGS.POSITIONS}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const updatePosition = async (id, data) => {
  try {
    const response = await axios.put(`${API_URL}${ENDPOINTS.SETTINGS.POSITIONS}/${id}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};

export const deletePosition = async (id) => {
  try {
    const response = await axios.delete(`${API_URL}${ENDPOINTS.SETTINGS.POSITIONS}/${id}`);
    return response;
  } catch (error) {
    throw error;
  }
};

export const getPositionsOptions = async (filters = {}) => {
  try {
    const response = await axios.get(`${API_URL}/positions/options`, { params: filters });
    return response;
  } catch (error) {
    throw error;
  }
};

export const saveRombelSettings = async (data) => {
  try {
    const response = await axios.post(`${API_URL}${ENDPOINTS.SETTINGS.ROMBEL}`, data);
    return response;
  } catch (error) {
    throw error;
  }
};
